import { cn } from "@monbits/ui";
import type { AMLRiskLevel } from "src/types";

interface RiskLevelBadgeProps {
	riskLevel: AMLRiskLevel;
	className?: string;
}

const riskStyles: Record<AMLRiskLevel, { className: string; label: string }> = {
	low: {
		className:
			"border-green-500/30 bg-green-50/50 text-green-700 dark:border-green-500/40 dark:bg-green-950/30 dark:text-green-400",
		label: "Low Risk",
	},
	medium: {
		className:
			"border-yellow-500/30 bg-yellow-50/50 text-yellow-700 dark:border-yellow-500/40 dark:bg-yellow-950/30 dark:text-yellow-400",
		label: "Medium Risk",
	},
	high: {
		className:
			"border-orange-500/30 bg-orange-50/50 text-orange-700 dark:border-orange-500/40 dark:bg-orange-950/30 dark:text-orange-400",
		label: "High Risk",
	},
	critical: {
		className:
			"border-red-500/30 bg-red-50/50 text-red-700 dark:border-red-500/40 dark:bg-red-950/30 dark:text-red-400",
		label: "Critical Risk",
	},
};

export function RiskLevelBadge({ riskLevel, className }: RiskLevelBadgeProps) {
	const { className: styleClass, label } = riskStyles[riskLevel];

	return (
		<span
			className={cn(
				"inline-flex items-center rounded border px-2.5 py-0.5 text-xs font-medium transition-colors",
				styleClass,
				className,
			)}
		>
			{label}
		</span>
	);
}
